import { cn } from "../../lib/utils";
import { CSSProperties, PropsWithChildren, StyleHTMLAttributes } from "react";

type TypographyProps = {
    children: React.ReactNode,
    className?: string,
}

export function TypographyH1(props: TypographyProps) {
    return (
        <h1 className={cn("scroll-m-20 text-3xl font-bold tracking-normal lg:text-4xl", props.className)}>
            {props.children}
        </h1>
    )
}

export function TypographyH2(props: TypographyProps) {
    return (
        <h2 className={cn("scroll-m-20 text-3xl font-semibold tracking-tight", props.className)}>
            {props.children}
        </h2>
    )
}

export function TypographyH3(props: TypographyProps) {
    return (
        <h3 className={cn("scroll-m-20 text-2xl font-semibold tracking-tight leading-none", props.className)}>
            {props.children}
        </h3>
    )
}

export function TypographyH4(props: TypographyProps & { style?: CSSProperties}) {
    return (
        <h4 style={props.style} className={cn("scroll-m-20 text-xl font-semibold tracking-tight", props.className)}>
            {props.children}
        </h4>
    )
}

export function TypographyP(props: TypographyProps) {
    return (
        <p className={cn("leading-7", props.className)}>
            {props.children}
        </p>
    )
}

export function TypographyBlockquote(props: TypographyProps) {
    return (
        <blockquote className={cn("mt-6 border-l-2 pl-6 italic", props.className)}>
            {props.children}
        </blockquote>
    )
}

export function TypographyLarge(props: TypographyProps) {
    return <div className={cn("text-lg font-semibold", props.className)}>{props.children}</div>
}

export function TypographySmall(props: TypographyProps) {
    return (
        <small className={cn("text-sm leading-none", props.className)}>{props.children}</small>
    )
}

export function TypographyMuted(props: TypographyProps) {
    return (
        <p className={cn("text-sm text-muted-foreground", props.className)}>{props.children}</p>
    )
}

